export default __webpack_public_path__ + "static/media/react.1b09d7ce.png";